module.exports = __webpack_public_path__ + "static/img/title1.ea07a23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/title1.svg
// module id = bWGT
// module chunks = 0